<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar class="primary white--text">
            <v-toolbar-title>Восстановление пароля</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="email"
                prepend-icon="email"
                :rules="rules.emailRules"
                required
                label="Email адрес"
                type="email"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <a class="bluelink pl8" @click.prevent="goBack()">&lt; Назад</a>
            <v-spacer></v-spacer>
            <v-btn type="submit" :disabled="!valid || enabledLog" @click="Recover">Восстановить</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import Globalrules from "../components/api/rules.js";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      rules: Globalrules,
      valid: true,
      show: false,
      email: "",
      password: "",
      someError: "",
    };
  },
  computed: {
    error() {
      return this.$store.getters.getError;
    },
    enabledLog() {
      return this.$store.getters.getProcessing;
    },
  },
  methods: {
    goBack(){
      this.$router.push('/login')
    },
    Recover() {
      var data = {
        email: this.email,
      };
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("RECOVER", data)
          .then((res) => {

            if(res.error){
              Swal.fire({
                icon: "error",
                title: "Ошибка",
                text: res.error
              });
            }else if(res.message){
              Swal.fire({
                icon: "info",
                title: "Внимание",
                text: res.message,
              });
            }
            this.$router.push("/login");
          })
      }
    },
  },
  mounted(){
    this.setTitle('Восстановление пароля')
  }
};
</script>

<style lang="sass">

</style>
